export default "__VITE_ASSET__uliumdbM__"